import { module } from 'modujs'
import BezierEasing from 'bezier-easing'

export default class extends module {
    constructor(m) {
        super(m)

        // Easing values
        this.easings = {
            power1In:    BezierEasing(0.550, 0.085, 0.680, 0.530),
            power1Out:   BezierEasing(0.250, 0.460, 0.450, 0.940),
            power1InOut: BezierEasing(0.455, 0.030, 0.515, 0.955),
            power2In:    BezierEasing(0.550, 0.055, 0.675, 0.190),
            power2Out:   BezierEasing(0.215, 0.610, 0.355, 1.000),
            power2InOut: BezierEasing(0.645, 0.045, 0.355, 1.000),
            power3In:    BezierEasing(0.895, 0.030, 0.685, 0.220),
            power3Out:   BezierEasing(0.165, 0.840, 0.440, 1.000),
            power3InOut: BezierEasing(0.770, 0.000, 0.175, 1.000),
            power4In:    BezierEasing(0.755, 0.050, 0.855, 0.060),
            power4Out:   BezierEasing(0.230, 1.000, 0.320, 1.000),
            power4InOut: BezierEasing(0.860, 0.000, 0.070, 1.000)
        }

        // Get easing type
        this.easingType = this.getData('type') ? this.getData('type') : 'power2InOut'
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Callbacks
    ///////////////
    onScrollProgress(progress) {
        this.smoothProgress = this.easings[this.easingType](progress)
        this.computeProgress()
    }

    ///////////////
    // Methods
    ///////////////
    computeProgress() {
        this.el.style.setProperty('--smooth-progress', this.smoothProgress)
    }
}
